import Vue from 'vue'
import VueCookie from 'vue-cookie'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

Vue.use(Router)
Vue.use(VueCookie)

var route = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: configRoutes()
})

function configRoutes() {
  return [{
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [{
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'master',
          redirect: '/master/study-program',
          name: 'Master',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'study-program',
              name: 'Program Study',
              component: () => import('../views/master/StudyProgram')
            },
            {
              path: 'study-program/:slug',
              name: 'Program Study Add',
              component: () => import('../views/master/StudyProgramAdd')
            },
            {
              path: 'subjects',
              name: 'Subject',
              component: () => import('../views/master/Subject')
            },
            {
              path: 'subjects/:slug',
              name: 'Subject Add',
              component: () => import('../views/master/SubjectAdd')
            },
            {
              path: 'study-program-group',
              name: 'Program Study Group',
              component: () => import('../views/master/StudyProgramGroup')
            },
            {
              path: 'study-program-group/:slug',
              name: 'Program Study Group Add',
              component: () => import('../views/master/StudyProgramGroupAdd')
            },
          ]
        },
        {
          path: 'mapping',
          redirect: '/mapping/study-program/major',
          name: 'Mapping',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'study-program/major',
              name: 'Study Program Major',
              component: () => import('../views/mapping/StudyProgramMajor')
            },
            {
              path: 'study-program/major/:id',
              name: 'Study Program Major Add',
              component: () => import('../views/mapping/StudyProgramMajorAdd')
            },
            {
              path: 'standard-deviation',
              name: 'Standard Deviation',
              component: () => import('../views/mapping/StandardDeviation')
            },
            {
              path: 'standard-deviation/:id',
              name: 'Standard Deviation Add',
              component: () => import('../views/mapping/StandardDeviationAdd')
            }
          ]
        },
        {
          path: 'soal',
          redirect: '/soal/list',
          name: 'Soal',
          meta: {
            requireAuth: true
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'list',
              name: 'List',
              component: () => import('../views/soal/List')
            },
            {
              path: 'tambah/:id',
              name: 'Tambah',
              component: () => import('../views/soal/QuestionAdd')
            },
            {
              path: 'baru/:gcode/:id',
              name: 'BuatBaru',
              component: () => import('../views/soal/QuestionDetail')
            },
            {
              path: 'series',
              name: 'Soal Mapping',
              component: () => import('../views/soal/Mapping')
            },
            {
              path: 'mapping/:id',
              name: 'Soal Mapping Add',
              component: () => import('../views/soal/MappingAdd')
            },
          ]
        },
        {
          path: 'exam-summary',
          name: 'Hasil-Ujian',
          component: () => import('../views/report/ExamSummary'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'order',
          name: 'Order List',
          component: () => import('../views/order/Index'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'user/list',
          name: 'User',
          component: () => import('../views/setting/User'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'user/add',
          name: 'User Add',
          component: () => import('../views/setting/UserAdd'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'slider',
          name: 'Slider',
          component: () => import('../views/slider/List'),
          meta: {
            requireAuth: true
          },
        },
        {
          path: 'slider/:id',
          name: 'Slider Add',
          component: () => import('../views/slider/Add'),
          meta: {
            requireAuth: true
          },
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/pages/Login')
    }
  ]
}

route.beforeEach((to, from, next) => {
  const authObj = getAuth()
  const now = Math.round((new Date()).getTime() / 1000);

  if (to.matched.some(r => r.meta.requireAuth)) {
    if (authObj == null || parseInt(authObj.expired_at) < now) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

function getAuth() {
  const auth = Vue.cookie.get("tryoutapp")
  const authObj = JSON.parse(auth)
  return authObj
}

export default route